import { combineReducers } from 'redux';

import {
	FETCH_DATA_REQUEST,
	FETCH_DATA_SUCCESS,
	FETCH_DATA_FAILURE,
	UPDATE_CURRENT_PAGE,
	SET_CURRENT_PAGE,
	ON_SEARCH_CHANGE,
	SET_FILE_VIEW,
	SET_FILE_SORT_ORDER,
	CLEAR_FILTERS,
	SET_FILTERED_IDS,
	LOGOUT_USER,
} from '../types';

const byId = (state = {}, action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			return {
				...state,
				...action.payload.files.entities.files,
			}

		case LOGOUT_USER:
			return {}

		default:
			return state;
	}
}

const allIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			return action.payload.files.result;

		case LOGOUT_USER:
			return []
		
		default:
			return state;
	}
}

const filteredIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			return action.payload.files.result;

		case SET_FILTERED_IDS:
			return action.payload;

		case LOGOUT_USER:
			return []
		
		default:
			return state;
	}
}

const isFetching = (state = false, action) => {
	switch (action.type) {
		case FETCH_DATA_REQUEST:
			return true;

		case FETCH_DATA_SUCCESS:
		case FETCH_DATA_FAILURE:
		case LOGOUT_USER:
			return false;


		default:
			return state;
	}
}

const errorMessage = (state = null, action) => {
	switch (action.type) {
		case FETCH_DATA_FAILURE:
			return action.payload;

		case FETCH_DATA_REQUEST:
		case FETCH_DATA_SUCCESS:
		case LOGOUT_USER:
			return null;

		default:
			return state;
	}
}

const initialFilter = {
	currentPage: 1,
	view: "list",
	search: "",
	sort: "date",
	order: false,
}

const updateCurrentPage = (state, payload) => {
	const { currentPage } = state;

	return {
		...state,
		currentPage: currentPage + payload
	}
}

const filter = (state = initialFilter, action) => {
	switch (action.type) {
		case UPDATE_CURRENT_PAGE:
			return updateCurrentPage(state, action.payload);

		case SET_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload
			}

		case SET_FILE_VIEW:
			return {
				...state,
				view: action.payload
			}

		case SET_FILE_SORT_ORDER:
			return {
				...state,
				sort: action.payload.name,
				order: action.payload.order,
			}
		case ON_SEARCH_CHANGE:
			return {
				...state,
				search: action.payload,
			}

		case CLEAR_FILTERS:
			return {
				...state,
				search: "",
			}

		case LOGOUT_USER:
			return initialFilter
		
		default:
			return state;
	}
}

const files = combineReducers({
	byId,
	allIds,
	filteredIds,
	isFetching,
	errorMessage,
	filter,
});
export default files;


export const amount = 10;
export const getIsFetching = (state) => state.isFetching;
export const getIds = (state) => state.allIds;
export const getFilteredIds = state => state.filteredIds;
export const getCurrentPage = (state) => state.filter.currentPage;
export const getSearchFilter = state => state.filter.search;
export const getView = (state) => state.filter.view;
export const getSort = (state) => state.filter.sort;
export const getOrder = (state) => state.filter.order;
export const getActiveToggle = state => state.filter.view;

export const getRecentFiles = (state) => {
	const ids = getIds(state);

	if (ids.length <= amount) {
		return ids.map(id => state.byId[id]);
	}

	return ids.slice(0, amount).map(id => state.byId[id]);
}

export const getNumberOfPages = (state) => {
	const ids = getFilteredIds(state);

	return Math.ceil(ids.length / amount);
}

export const getFilesBySelectedCircles = (state, circles) => {
	const ids = getIds(state);

	return ids.filter(id => circles.some(circle => state.byId[id].circles.includes(circle)));
}

export const getFilesBySelectedTypes = (state, types) => {
	const ids = getIds(state);

	return ids.filter(id => types.some(type => state.byId[id].types.includes(type)));
}

export const getFilesBySelectedFunds = (state, funds) => {
	const ids = getIds(state);

	return ids.filter(id => funds.some(fund => state.byId[id].funds.includes(fund)));
}

export const getFilesBySelectedYears = (state, years) => {
	const ids = getIds(state);
	
	return ids.filter(id => years.some(year => state.byId[id].years.includes(year)));
}


export const getFilesFromIds = (files, ids) => {
	return ids.map(id => files.byId[id]);
}

export const getFilteredFiles = state => {
	const ids = getFilteredIds(state);
	const currentPage = getCurrentPage(state);
	let pagedIds;

	if (ids.length <= amount) {
		pagedIds = ids;
	} else {
		const firstID = (currentPage * amount) - amount;
		const lastID = currentPage * amount;
	
		pagedIds = ids.slice(firstID, lastID);
	}

	return pagedIds.map(id => state.byId[id]);
}


// WEBPACK FOOTER //
// ./src/store/files/reducer.js